import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { Home } from './pages/Home';
import { Shop } from './pages/Shop';
import { CategoryDetail } from './pages/CategoryDetail';
import { ProductDetail } from './pages/ProductDetail';
import { HowItWorks } from './pages/HowItWorks';
import { Labs } from './pages/Labs';
import { Pricing } from './pages/Pricing';
import { About } from './pages/About';
import { GetStarted } from './pages/GetStarted';
import { BrandProvider } from './contexts/BrandContext';
interface AppProps {
  /** Which client brand the template renders. Adding a brand is a theme entry, not a fork. */
  brand?: 'republic' | 'verdant';
}
export function App({
  brand = 'republic'
}: AppProps) {
  return <BrandProvider brandId={brand} data-id="element-0" data-mp="28s2ynca15zvg">
      <BrowserRouter data-id="element-1" data-mp="23w4e5zrtp20b">
        <ScrollToTop data-id="element-2" data-mp="23ujho4ly78zt" />
        <div className="flex min-h-screen w-full flex-col bg-cream" data-id="element-3" data-mp="23t8i6gzjcnei">
          <Header data-id="element-4" data-mp="3ij63w8owfj7c" />
          <Routes data-id="element-5" data-mp="3ijpd910hgz9r">
            <Route path="/" element={<Home data-id="element-7" data-mp="3ml14tc2x3ukl" />} data-id="element-6" data-mp="3ii4r9zs8ioni" />
            <Route path="/shop" element={<Shop data-id="element-9" data-mp="3mjq2zht18ww4" />} data-id="element-8" data-mp="3mkhmvvd9p66k" />
            <Route path="/shop/:slug" element={<ProductDetail data-id="element-11" data-mp="3rbzomln47asl" />} data-id="element-10" data-mp="3mj6lu3b7icj5" />
            <Route path="/categories/:slug" element={<CategoryDetail data-id="element-13" data-mp="5ygolyg4xb6" />} data-id="element-12" data-mp="3rcsulke91w9o" />
            <Route path="/how-it-works" element={<HowItWorks data-id="element-15" data-mp="82ld64660ci" />} data-id="element-14" data-mp="4wxfu7a14id" />
            <Route path="/labs" element={<Labs data-id="element-17" data-mp="2zm4yimrfnh2v" />} data-id="element-16" data-mp="2zld0l5ad579f" />
            <Route path="/pricing" element={<Pricing data-id="element-19" data-mp="2znfyebhrc4op" />} data-id="element-18" data-mp="2zmo5j8fjol24" />
            <Route path="/about" element={<About data-id="element-21" data-mp="33ngfk3w8qtzg" />} data-id="element-20" data-mp="33m5c656pjo8v" />
            <Route path="/get-started" element={<GetStarted data-id="element-23" data-mp="38m1jadapbvsn" />} data-id="element-22" data-mp="33oriy2lrxzq1" />
            <Route path="*" element={<Home data-id="element-25" data-mp="38kgmsi4tu2s5" />} data-id="element-24" data-mp="38kqgafp2ys2l" />
          </Routes>
          <Footer data-id="element-26" data-mp="3dkl6eh117dml" />
        </div>
      </BrowserRouter>
    </BrandProvider>;
}
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
  }, [pathname]);
  return null;
}